import auth from "../../../auth/auth-helper";

const AtmTransactionList = async (signal,credentials) => {
  console.log(auth.getuserType());
    try {
      let response = await fetch(
        process.env["REACT_APP_API_HOST"] + "/api/" + auth.getuserType() + "/transactions/atm",
        {
          method: "GET",
          signal: signal,
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'x-access-token':credentials
        },
        }
      );
      return await response.json();
    } catch (err) {
      console.log(err);
    }
  };

  export {  AtmTransactionList };